import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LazyMotion, domAnimation } from "framer-motion";
import Landing from "@/pages/Landing";
import { Analytics } from "@/components/Analytics";
import { ScrollToTop } from "@/components/ScrollToTop";

const LocationPage = lazy(() => import("@/pages/LocationPage"));
const LegalPage = lazy(() => import("@/pages/LegalPage"));
const AdminPortal = lazy(() => import("@/pages/AdminPortal"));
const BookingPage = lazy(() => import("@/pages/BookingPage"));

const Fallback = () => <div className="min-h-screen bg-[#0a0d12]" />;

export default function App() {
  return (
    <LazyMotion features={domAnimation}>
      <BrowserRouter>
        <ScrollToTop />
        <Analytics />
        <Suspense fallback={<Fallback />}>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/argyle" element={<LocationPage slug="argyle" />} />
            <Route path="/lantana" element={<LocationPage slug="lantana" />} />
            <Route path="/book" element={<BookingPage />} />
            <Route path="/admin" element={<AdminPortal />} />
            <Route path="/admin/leads" element={<AdminPortal tab="leads" />} />
            <Route path="/terms" element={<LegalPage slug="terms" />} />
            <Route path="/privacy" element={<LegalPage slug="privacy" />} />
            <Route path="/cookies" element={<LegalPage slug="cookies" />} />
            <Route path="*" element={<Landing />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </LazyMotion>
  );
}
